import { useEffect, useState } from "react"
import { toast } from "react-toastify";
import percentage from "../Assets/percent.png"
import inr from "../Assets/currency.png"
import { useUser } from "../Context";
import { Link, useNavigate } from "react-router-dom";
import { addDoc, arrayUnion, collection, doc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../Firebase";
import FileSaver from "file-saver";
import * as XLSX from "xlsx"
import Loading from "./Loading";
import warning from "../Assets/warning.png"
import warnCharacter from "../Assets/warnCharacter.png"
import graph9 from "../Assets/graph10.png"
import download from "../Assets/download.png"

export default function AddLease() {
    const navigate = useNavigate()
    const { user, setUser, loading, setLoading, setLeases } = useUser()
    // const headingArray=["Lessor Name","Location", "City", "Monthly Rent (in ₹)", "Escalation Rate (in %)", "Discount Rate (in %)", "Agreement Date(dd-mm-yyyy)", "Possesion Date (dd-mm-yyyy)", "Start Date (dd-mm-yyyy)", "End Date (dd-mm-yyyy)", "Security Deposit (in ₹)", "Asset Type (property/equipment/vehicle)", "Rent in (arrear/advance)"]
    const [rent, setRent] = useState(0);
    const [type, setType] = useState('property');
    const [agreeDate, setAgreeDate] = useState();
    const [possesDate, setPossesDate] = useState();
    const [paymentType, setPaymentType] = useState('arrear');
    const [escalationRate, setEscalationRate] = useState(0);
    const [escalationPeriod, setEscalationPeriod] = useState(0)
    const [interest, setInterest] = useState(0);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [securityDeposit, setSecurityDeposit] = useState(0);
    const [period, setPeriod] = useState();
    const [lesseeName, setLesseeName] = useState()
    const [location, setLocation] = useState()
    const [city, setCity] = useState()
    const [leaseData, setLeaseData] = useState([])
    const [file1, setFile1] = useState()
    const [file2, setFile2] = useState()
    const headingArray = ["Lessor Name", "Location", "City", "Monthly Rent (in ₹)", "Escalation Rate (in %)", "Escalation Period (in months)", "Discount Rate (in %)", "Agreement Date(dd-mm-yyyy)", "Possesion Date (dd-mm-yyyy)", "Start Date (dd-mm-yyyy)", "End Date (dd-mm-yyyy)", "Security Deposit (in ₹)", "Asset Type (property/equipment/vehicle)", "Rent in (arrear/advance)"];

    function calculateDuration(startDate, endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const diffInMonths = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
        // console.log(start, end, diffInMonths)
        if (diffInMonths < 0) {
            toast.warn("Duration cannot be this short.");
            return;
        }
        return diffInMonths;
    }

    function submitForm(e) {
        e.preventDefault()
        console.log(lesseeName, escalationPeriod, location, city, rent, escalationRate, interest, startDate, endDate, securityDeposit);
        if (!lesseeName || !escalationPeriod || !location || !city || !rent || !escalationRate || !interest || !startDate || !endDate || !securityDeposit) {
            toast.warn("Please fill in all fields.");
            return;
        }
        if (rent < 0) {
            toast.warn("Rent cannot be less than 0.");
            return;
        }
        if (escalationRate < 0 && escalationRate > 1) {
            toast.warn("Incoorect value for escalation rate.");
            return;
        }
        if (interest < 0 && interest > 1) {
            toast.warn("Incoorect value for interest rate.");
            return;
        }
        if (securityDeposit < 0) {
            toast.warn("Deposit cannot be less than 0.");
            return;
        }

        if (startDate > endDate) {
            toast.warn("Incorrect duration specified.");
            return;
        }

        if (!agreeDate) {
            setAgreeDate(startDate)
        }
        if (!possesDate) {
            setPossesDate(startDate)
        }

        // if()

        // console.log(rent, escalationRate, interest, startDate, endDate, securityDeposit)
        setPeriod(() => {
            return calculateDuration(startDate, endDate)
        });
    }
    useEffect(() => {
        if (period) {
            calculateLeaseLiability();
        }
    }, [period])

    const calculateMonth = (startDate, index) => {
        const date = new Date(startDate);
        date.setMonth(date.getMonth() + index - 1);
        // console.log(date);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    async function calculateLeaseLiability() {
        let rent1 = parseFloat(rent), rent2 = parseFloat(rent);
        let escalation = parseFloat(escalationRate);
        let leaseLiablility = 0;
        for (let i = 1; i <= period; i++) {
            if (i % escalationPeriod === 1 && i !== 1) {
                rent1 += rent1 * escalation;
            }
            let discountFactor;
            if (paymentType === 'arrear') {
                discountFactor = 1 / Math.pow((1 + (interest / 12)), i);
            }
            else {
                discountFactor = 1 / Math.pow((1 + (interest / 12)), i - 1);
            }
            leaseLiablility += discountFactor * rent1;
        }
        let openingLeaseLiability = leaseLiablility;
        let monthlyInterest = 0;
        let ClosingROU = 0;
        let ROUAsset;
        let pvOfSD;
        let closingPVSD = 0;
        let interestIncome = 0;
        let ppRent = 0;
        let openingROUAsset = 0
        for (let i = 1; i <= period; i++) {
            if (i % escalationPeriod === 1 && i !== 1) {
                rent2 += rent2 * escalation;
            }
            let discountFactor;
            if (paymentType === 'arrear') {
                discountFactor = 1 / Math.pow((1 + (interest / 12)), i);
            }
            else {
                discountFactor = 1 / Math.pow((1 + (interest / 12)), i - 1);
            }
            if (!closingPVSD) {
                pvOfSD = securityDeposit / Math.pow(1 + (interest / 12), period - 1);
            }
            else {
                pvOfSD = closingPVSD;
            }
            if (i === 1 && paymentType === 'advance') {
                monthlyInterest = 0;
            }
            else {
                monthlyInterest = openingLeaseLiability * (interest / 12);
            }
            let closingBalance = openingLeaseLiability + monthlyInterest - rent2;
            ppRent = ppRent === 0 ? securityDeposit - pvOfSD : ppRent;
            if (ClosingROU) {
                ROUAsset = ClosingROU;
            }
            else {
                ROUAsset = ppRent + leaseLiablility;
                openingROUAsset = ROUAsset;
            }
            if (closingPVSD) {
                interestIncome = pvOfSD * (interest / 12);
            }
            closingPVSD = pvOfSD + interestIncome;
            let depreciation = (ppRent + leaseLiablility) / period;
            ClosingROU = ROUAsset - depreciation;
            let ammortizationSchedule = leaseData;
            ammortizationSchedule.push({
                period: i,
                discountFactor: discountFactor,
                month: calculateMonth(startDate, i),
                rent: rent2,
                payment: rent2,
                rentIntoDisc: (discountFactor * rent2),
                openingLeaseLiability: openingLeaseLiability,
                monthlyInterest: monthlyInterest,
                closingBalance: closingBalance,
                pvOfSD: pvOfSD,
                ROUAsset: ROUAsset,
                depreciation: depreciation,
                closingRou: ClosingROU,
                interestIncome: interestIncome,
                closingPvofSD: closingPVSD
            })
            setLeaseData(ammortizationSchedule);
            openingLeaseLiability = closingBalance;
            ROUAsset = ClosingROU;
            pvOfSD = closingPVSD;
        }

        try {
            const leaseDocRef = await addDoc(collection(db, "lease"),
                { lesseeId: user.uid, escalationPeriod, lesseeName, location, type, paymentType, agreeDate, possesDate, city, rent: parseFloat(rent), escalationRate, interest, startDate, endDate, securityDeposit: parseFloat(securityDeposit), period, prepaidRent: parseFloat(ppRent), openingROUAsset: parseFloat(openingROUAsset), openingLeaseLiability: parseFloat(leaseLiablility) })
            if (leaseDocRef) {
                await updateDoc(doc(db, "lessee", user.uid), {
                    leaseList: arrayUnion(leaseDocRef.id)
                })
                await setDoc(doc(db, "ammortization", leaseDocRef.id), {
                    data: leaseData
                })
                setUser({ ...user, leaseList: [...user.leaseList, leaseDocRef.id] });
                setLeases((prev) => [...prev, { lesseeId: user.uid, escalationPeriod, lesseeName, location, type, paymentType, agreeDate, possesDate, city, rent: parseFloat(rent), escalationRate, interest, startDate, endDate, securityDeposit: parseFloat(securityDeposit), period, prepaidRent: parseFloat(ppRent), openingROUAsset: parseFloat(openingROUAsset), openingLeaseLiability: parseFloat(leaseLiablility) }])
            }
        } catch (error) {
            toast.error("Error in creating new lease.")
            console.error("Error in creating new lease", error);
        }

        document.getElementsByTagName('form')[0].reset();
        setLesseeName()
        setLocation()
        setCity()
        setRent()
        setEscalationRate()
        setEscalationPeriod()
        setInterest()
        setStartDate()
        setEndDate()
        setSecurityDeposit()
        setPeriod()
        toast.success("New entry created.")
        navigate(-1);
    }

    function checkTemplate1(arr) {
        if (arr.length !== headingArray.length) return false;
        for (let i = 0; i < headingArray.length; i++) {
            if (headingArray[i].toLocaleLowerCase() !== arr[i].trim().toLocaleLowerCase()) {
                toast.error("Uploaded file does not match the template.")
                console.log(headingArray[i].toLocaleLowerCase(), "!==", arr[i].trim().toLocaleLowerCase())
                return false;
            }
        }
        return true;
    }
    //to be worked upon
    function checkTemplate2(arr) {
        if (arr.length !== headingArray.length) return false;
        for (let i = 0; i < headingArray.length; i++) {
            if (headingArray[i].toLocaleLowerCase() !== arr[i].trim().toLocaleLowerCase()) {
                toast.error("Uploaded file does not match the template.")
                console.log(headingArray[i].toLocaleLowerCase(), "!==", arr[i].trim().toLocaleLowerCase())
                return false;
            }
        }
        return true;
    }

    function reverseDate(date) {
        // console.log(date)
        // console.log(new Date(Math.round((date - 25569) * 86400 * 1000)).toISOString().split('T')[0])
        return new Date(Math.round((date - 25569) * 86400 * 1000)).toISOString().split('T')[0]
        // var returnDateTime = 25569.0 + ((date.getTime() - (date.getTimezoneOffset() * 60 * 1000)) / (1000 * 60 * 60 * 24));
        // return returnDateTime.toString().substr(0,5);
    }

    async function calculateExcelLeaseLiability(arr) {
        let lesseeName = arr[0];
        let location = arr[1];
        let city = arr[2];
        let rent = parseInt(arr[3]);
        let escalationRate = parseFloat(arr[4]) / 100;
        let escalationPeriod = parseInt(arr[5])
        let interest = parseFloat(arr[6]) / 100;
        let agreeDate = reverseDate(arr[7]);
        let possesDate = reverseDate(arr[8]);
        let startDate = reverseDate(arr[9]);
        let endDate = reverseDate(arr[10]);
        let securityDeposit = parseFloat(arr[11]);
        let type = arr[12].trim().toLocaleLowerCase();
        let paymentType = arr[13].trim().toLocaleLowerCase();
        let period = calculateDuration(startDate, endDate)
        // console.log(period)
        let rent1 = parseFloat(rent), rent2 = parseFloat(rent);
        let escalation = escalationRate;
        let leaseLiablility = 0;
        let leaseData = []
        for (let i = 1; i <= period; i++) {
            if (i % escalationPeriod === 1 && i !== 1) {
                rent1 += rent1 * escalation;
            }
            let discountFactor;
            if (paymentType === 'arrear') {
                discountFactor = 1 / Math.pow((1 + (interest / 12)), i);
            }
            else {
                discountFactor = 1 / Math.pow((1 + (interest / 12)), i - 1);
            }
            leaseLiablility += discountFactor * rent1;
        }
        let openingLeaseLiability = leaseLiablility;
        let monthlyInterest = 0;
        let ClosingROU = 0;
        let ROUAsset;
        let pvOfSD;
        let closingPVSD = 0;
        let interestIncome = 0;
        let ppRent = 0;
        let openingROUAsset = 0
        for (let i = 1; i <= period; i++) {
            if (i % escalationPeriod === 1 && i !== 1) {
                rent2 += rent2 * escalation;
            }
            let discountFactor;
            if (paymentType === 'arrear') {
                discountFactor = 1 / Math.pow((1 + (interest / 12)), i);
            }
            else {
                discountFactor = 1 / Math.pow((1 + (interest / 12)), i - 1);
            }
            if (!closingPVSD) {
                pvOfSD = securityDeposit / Math.pow(1 + (interest / 12), period - 1);
            }
            else {
                pvOfSD = closingPVSD;
            }
            if (i === 1 && paymentType === 'advance') {
                monthlyInterest = 0;
            }
            else {
                monthlyInterest = openingLeaseLiability * (interest / 12);
            }
            let closingBalance = openingLeaseLiability + monthlyInterest - rent2;
            ppRent = ppRent === 0 ? securityDeposit - pvOfSD : ppRent;
            if (ClosingROU) {
                ROUAsset = ClosingROU;
            }
            else {
                ROUAsset = ppRent + leaseLiablility;
                openingROUAsset = ROUAsset;
            }
            if (closingPVSD) {
                interestIncome = pvOfSD * (interest / 12);
            }
            closingPVSD = pvOfSD + interestIncome;
            let depreciation = (ppRent + leaseLiablility) / period;
            ClosingROU = ROUAsset - depreciation;
            let ammortizationSchedule = leaseData;
            ammortizationSchedule.push({
                period: i,
                discountFactor: discountFactor,
                month: calculateMonth(startDate, i),
                rent: rent2,
                payment: rent2,
                rentIntoDisc: (discountFactor * rent2),
                openingLeaseLiability: openingLeaseLiability,
                monthlyInterest: monthlyInterest,
                closingBalance: closingBalance,
                pvOfSD: pvOfSD,
                ROUAsset: ROUAsset,
                depreciation: depreciation,
                closingRou: ClosingROU,
                interestIncome: interestIncome,
                closingPvofSD: closingPVSD
            })
            // setLeaseData(ammortizationSchedule);
            openingLeaseLiability = closingBalance;
            ROUAsset = ClosingROU;
            pvOfSD = closingPVSD;
        }
        // return new Promise(async(resolve,reject)=>{
        try {
            // console.log({
            //     lesseeId: user.uid, lesseeName, location, type, paymentType, agreeDate, possesDate, city, rent, escalationRate, interest, startDate, endDate, securityDeposit, period, prepaidRent:ppRent, openingROUAsset:openingROUAsset, openingLeaseLiability:leaseLiablility
            // })
            setLeases((prev) => [...prev, {
                lesseeId: user.uid, lesseeName, location, type, paymentType, agreeDate, possesDate, city, rent: parseFloat(rent), escalationRate, escalationPeriod, interest, startDate, endDate, securityDeposit, period, prepaidRent: ppRent, openingROUAsset: openingROUAsset, openingLeaseLiability: leaseLiablility
            }])
            const leaseDocRef = await addDoc(collection(db, "lease"),
                {
                    lesseeId: user.uid, lesseeName, location, type, paymentType, agreeDate, possesDate, city, rent: parseFloat(rent), escalationRate, escalationPeriod, interest, startDate, endDate, securityDeposit, period, prepaidRent: ppRent, openingROUAsset: openingROUAsset, openingLeaseLiability: leaseLiablility
                })
            if (leaseDocRef) {
                await updateDoc(doc(db, "lessee", user.uid), {
                    leaseList: arrayUnion(leaseDocRef.id)
                })
                await setDoc(doc(db, "ammortization", leaseDocRef.id), {
                    data: leaseData
                })
                return leaseDocRef.id
                // setUser({ ...user, leaseList: [...user.leaseList, leaseDocRef.id] });
            }
            // onComplete()
            // resolve()
        } catch (error) {
            toast.error("Error in creating new lease.")
            console.error("Error in creating new lease", error);
            setLoading(false)
            // reject();
        }
        // })
    }

    // async function readExcel(){
    //     setLoading(true);
    //     try{
    //         if (file) {
    //           const reader = new FileReader();
    //           reader.onload = async() => {
    //             const data = reader.result
    //             const workbook = XLSX.read(data, { type: 'array' });
    //             workbook.SheetNames.forEach(async(sheetName) => {
    //               const worksheet = workbook.Sheets[sheetName];
    //               const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    //               console.log(`Data from sheet '${sheetName}':`, sheetData);
    //             //   console.log(sheetData[0]==Array(headingArray));
    //             if(sheetData.length<=1){
    //                 toast.error("No entries detected.")
    //             }
    //             if(checkTemplate1(sheetData[0])){
    //                 for(let i=1;i<sheetData.length;i++){
    //                     await calculateExcelLeaseLiability(sheetData[i]);
    //                 }   
    //             }
    //            });
    //           };
    //           reader.readAsArrayBuffer(file[0]);
    //         }
    //     }
    //     catch(err){
    //         console.log("Error in reading excel.")
    //     }
    //     setFile()
    //     setLoading(false)
    // }


    // newwer
    // async function readExcel() {
    //     setLoading(true);
    //     console.log("Loading set to true");
    //     try {
    //         if (file) {
    //             const reader = new FileReader();
    //             reader.onload = async () => {
    //                 const data = reader.result;
    //                 const workbook = XLSX.read(data, { type: 'array' });
    //                 await Promise.all(workbook.SheetNames.map(async (sheetName) => {
    //                     const worksheet = workbook.Sheets[sheetName];
    //                     const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    //                     console.log(`Data from sheet '${sheetName}':`, sheetData);

    //                     if (sheetData.length <= 1) {
    //                         toast.error("No entries detected.");
    //                         return;
    //                     }
    //                     if (checkTemplate1(sheetData[0])) {
    //                         await Promise.all(sheetData.slice(1).map(async (row) => {
    //                             console.log("ROW IS: ",row)
    //                             // await calculateExcelLeaseLiability(row);
    //                             await new Promise((resolve, reject) => {
    //                                 calculateExcelLeaseLiability(row, resolve);
    //                             });
    //                         }));
    //                     }
    //                     setLoading(false);
    //                 }));
    //             };
    //             reader.readAsArrayBuffer(file[0]);
    //         }
    //     } catch (err) {
    //         console.error("Error in reading excel:", err);
    //         toast.error("Error in reading excel.");
    //     }
    //     console.log("Loading set to false")
    // }



    async function readExcel1() {
        setLoading(true);
        // console.log("Loading set to true");
        try {
            if (file1) {
                const reader = new FileReader();
                reader.onload = async () => {
                    const leaseArray = [];
                    const data = reader.result;
                    const workbook = XLSX.read(data, { type: 'array' });
                    await Promise.all(workbook.SheetNames.map(async (sheetName) => {
                        const worksheet = workbook.Sheets[sheetName];
                        const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                        if (sheetData.length <= 1) {
                            toast.error("No entries detected.");
                            return;
                        }
                        if (checkTemplate1(sheetData[0])) {
                            await Promise.all(sheetData.slice(1).map(async (row) => {
                                // console.log("ROW IS: ", row);
                                const leaseId = await calculateExcelLeaseLiability(row);
                                leaseArray.push(leaseId)
                            }));
                        }
                    }));
                    setUser({ ...user, leaseList: [...user.leaseList, ...leaseArray] });
                    setLoading(false);
                };
                reader.readAsArrayBuffer(file1[0]);
            }
        } catch (err) {
            console.error("Error in reading excel:", err);
            toast.error("Error in reading excel.");
            setLoading(false);
        }
        navigate('/dashboard')
        // console.log("Loading set to false");
    }


    // async function readExcel2() {
    //     setLoading(true);
    //     // console.log("Loading set to true");
    //     try {
    //         if (file2) {
    //             const reader = new FileReader();
    //             reader.onload = async () => {
    //                 const data = reader.result;
    //                 const workbook = XLSX.read(data, { type: 'array' });
    //                 const masterSheet = workbook.Sheets[workbook.SheetNames[0]];
    //                 const masterData = XLSX.utils.sheet_to_json(masterSheet, { header: 1 });
    //                 if (masterData.length <= 1) {
    //                     toast.error("No entries detected in master sheet.");
    //                     setLoading(false);
    //                     return;
    //                 }
    //                 const leasePromises = masterData.slice(1).map(async (row, index) => {
    //                     const leaseName = `Lease ${index + 1}`;
    //                     const leaseSheet = workbook.Sheets[leaseName];
    //                     let tempLease = {
    //                         lesseeId: user.uid,
    //                         lesseeName: row[0],
    //                         location: row[1],
    //                         city: row[2],
    //                         rent: row[3],
    //                         escalationRate: row[4] / 100,
    //                         escalationPeriod: row[5],
    //                         interest: row[6] / 100,
    //                         agreeDate: row[7],
    //                         possesDate: row[8],
    //                         startDate: row[9],
    //                         endDate: row[10],
    //                         securityDeposit: row[11],
    //                         type: row[12],
    //                         paymentType: row[13],
    //                         openingLeaseLiability: row[14],
    //                         openingROUAsset: row[15],
    //                         prepaidRent: row[16],
    //                         earlyTermination: row[17]
    //                     }
    //                     if (leaseSheet) {
    //                         let tempAmmortization = []
    //                         const leaseData = XLSX.utils.sheet_to_json(leaseSheet, { header: 1 });
    //                         tempAmmortization = leaseData.splice(1).map((item) => {
    //                             return {
    //                                 period: item[0],
    //                                 month: item[1],
    //                                 discountFactor: item[2],
    //                                 rent: item[3],
    //                                 payment: item[4],
    //                                 rentIntoDisc: item[5],
    //                                 openingLeaseLiability: item[6],
    //                                 monthlyInterest: item[7],
    //                                 closingBalance: item[8],
    //                                 pvOfSD: item[9],
    //                                 ROUAsset: item[10],
    //                                 depreciation: item[11],
    //                                 closingRou: item[12],
    //                                 interestIncome: item[13],
    //                                 closingPvofSD: item[14]
    //                             }
    //                         })
    //                         console.log("For row: ", tempLease, "the ammortization is: ", tempAmmortization)
    //                         const leaseDocRef = await addDoc(collection(db, "lease", tempLease))
    //                         if (leaseDocRef) {
    //                             await updateDoc(doc(db, "lessee", user.uid), {
    //                                 leaseList: arrayUnion(leaseDocRef.id)
    //                             })
    //                             await setDoc(doc(db, "ammortization", leaseDocRef.id), {
    //                                 data: tempAmmortization
    //                             })
    //                             setUser({ ...user, leaseList: [...user.leaseList, leaseDocRef.id] });
    //                             setLeases((prev) => [...prev, tempLease])
    //                         }
    //                     } else {
    //                         toast.error(`Sheet ${leaseName} not found.`);
    //                     }
    //                 });
    //                 await Promise.all(leasePromises);
    //                 toast.success('File uploaded successfully.');
    //                 setLoading(false);


    //                 // await Promise.all(workbook.SheetNames.map(async (sheetName) => {
    //                 //     const worksheet = workbook.Sheets[sheetName];
    //                 //     const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    //                 //     if (sheetData.length <= 1) {
    //                 //         toast.error("No entries detected.");
    //                 //         return;
    //                 //     }
    //                 //     if (checkTemplate1(sheetData[0])) {
    //                 //         await Promise.all(sheetData.slice(1).map(async (row) => {
    //                 //             // console.log("ROW IS: ", row);
    //                 //             const leaseId = await calculateExcelLeaseLiability(row);
    //                 //             leaseArray.push(leaseId)
    //                 //         }));
    //                 //     }
    //                 // }));
    //                 // setUser({ ...user, leaseList: [...user.leaseList, ...leaseArray] });
    //                 // setLoading(false);
    //             };
    //             reader.readAsArrayBuffer(file2[0]);
    //         }
    //     } catch (err) {
    //         console.error("Error in reading excel:", err);
    //         toast.error("Error in reading excel.");
    //         setLoading(false);
    //     }
    //     navigate('/dashboard')
    //     // console.log("Loading set to false");
    // }
    const readExcel2 = async () => {
        setLoading(true);
        try {
            if (file2) {
                const reader = new FileReader();
                reader.onload = async () => {
                    const data = reader.result;
                    const workbook = XLSX.read(data, { type: 'array' });
                    const masterSheet = workbook.Sheets[workbook.SheetNames[0]];
                    const masterData = XLSX.utils.sheet_to_json(masterSheet, { header: 1 });

                    if (masterData.length <= 1) {
                        toast.error("No entries detected in master sheet.");
                        setLoading(false);
                        return;
                    }

                    const leasePromises = masterData.slice(1).map(async (row, index) => {
                        const leaseName = `Lease ${index + 1}`;
                        const leaseSheet = workbook.Sheets[leaseName];
                        const tempLease = {
                            lesseeId: user.uid,
                            period:calculateDuration(reverseDate(row[9]),reverseDate(row[10])),
                            lesseeName: row[0],
                            location: row[1],
                            city: row[2],
                            rent: parseFloat(row[3]),
                            escalationRate: parseFloat(row[4] / 100),
                            escalationPeriod: parseInt(row[5]),
                            interest: parseFloat(row[6] / 100),
                            agreeDate: reverseDate(row[7]),
                            possesDate:reverseDate( row[8]),
                            startDate: reverseDate(row[9]),
                            endDate: reverseDate(row[10]),
                            securityDeposit: parseFloat(row[11]),
                            type: row[12].toLocaleLowerCase(),
                            paymentType: row[13].toLocaleLowerCase(),
                            openingLeaseLiability: parseFloat(row[14]),
                            openingROUAsset: parseFloat(row[15]),
                            prepaidRent: parseFloat(row[16]),
                            earlyTermination: row[17]?row[17]:false
                        };

                        if (leaseSheet) {
                            const leaseData = XLSX.utils.sheet_to_json(leaseSheet, { header: 1 });
                            const tempAmmortization = leaseData.slice(1).map(item => ({
                                period: item[0],
                                month: reverseDate(item[1]),
                                discountFactor: parseFloat(item[2]),
                                rent: parseFloat(item[3]),
                                payment: parseFloat(item[4]),
                                rentIntoDisc: parseFloat(item[5]),
                                openingLeaseLiability: parseFloat(item[6]),
                                monthlyInterest: parseFloat(item[7]),
                                closingBalance: parseFloat(item[8]),
                                pvOfSD: parseFloat(item[9]),
                                ROUAsset: parseFloat(item[10]),
                                depreciation: parseFloat(item[11]),
                                closingRou: parseFloat(item[12]),
                                interestIncome: parseFloat(item[13]),
                                closingPvofSD:parseFloat( item[14])
                            }));

                            try {
                                const leaseDocRef = await addDoc(collection(db, "lease"), tempLease);
                                if (leaseDocRef) {
                                    await updateDoc(doc(db, "lessee", user.uid), {
                                        leaseList: arrayUnion(leaseDocRef.id)
                                    });
                                    await setDoc(doc(db, "ammortization", leaseDocRef.id), {
                                        data: tempAmmortization
                                    });
                                    setUser(prevUser => ({
                                        ...prevUser,
                                        leaseList: [...prevUser.leaseList, leaseDocRef.id]
                                    }));
                                    setLeases(prev => [...prev, tempLease]);
                                }
                            } catch (err) {
                                console.error("Error creating lease document:", err);
                                toast.error("Error creating lease document.");
                            }
                        } else {
                            toast.error(`Sheet ${leaseName} not found.`);
                        }
                    });

                    await Promise.all(leasePromises);
                    toast.success('File uploaded successfully.');
                    setLoading(false);
                    navigate('/dashboard')
                };

                reader.readAsArrayBuffer(file2[0]);
            }
        } catch (err) {
            console.error("Error in reading excel:", err);
            toast.error("Error in reading excel.");
            setLoading(false);
            navigate('/dashboard')
        }
    };

    useEffect(() => {
        if (file1) {
            // console.log(file);
            readExcel1();
        }
    }, [file1])

    useEffect(() => {
        if (file2) {
            // console.log(file);
            readExcel2();
        }
    }, [file2])

    const handleDownload = () => {
        const base64Template = "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"
        const sliceSize = 1024
        const byteCharacters = window.atob(base64Template);
        const bytesLength = byteCharacters.length;
        let slicesCount = Math.ceil(bytesLength / sliceSize);
        let byteArrays = new Array(slicesCount);
        for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            let begin = sliceIndex * sliceSize;
            let end = Math.min(begin + sliceSize, bytesLength);
            let bytes = new Array(end - begin);
            for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        FileSaver.saveAs(
            new Blob(byteArrays, { type: "application/vnd.ms-excel" }),
            "Lease Template.xlsx"
        );
    };

    const handleDownload2 = () => {
        const base64Template = "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"
        const sliceSize = 1024
        const byteCharacters = window.atob(base64Template);
        const bytesLength = byteCharacters.length;
        let slicesCount = Math.ceil(bytesLength / sliceSize);
        let byteArrays = new Array(slicesCount);
        for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            let begin = sliceIndex * sliceSize;
            let end = Math.min(begin + sliceSize, bytesLength);
            let bytes = new Array(end - begin);
            for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        FileSaver.saveAs(
            new Blob(byteArrays, { type: "application/vnd.ms-excel" }),
            "Bulk Lease Template.xlsx"
        );
    };

    const handleDrop1 = (event) => {
        event.preventDefault();
        const droppedFiles = event.dataTransfer.files;

        if (droppedFiles.length > 1) {
            toast.error("Only one sheet at a time.");
            return;
        }
        if (droppedFiles.length > 0) {
            setFile1(droppedFiles);
            console.log('Dropped file(s):', droppedFiles);
        }
    };

    const handleDrop2 = (event) => {
        event.preventDefault();
        const droppedFiles = event.dataTransfer.files;

        if (droppedFiles.length > 1) {
            toast.error("Only one sheet at a time.");
            return;
        }
        if (droppedFiles.length > 0) {
            setFile2(droppedFiles);
            console.log('Dropped file(s):', droppedFiles);
        }
    };

    const [isDragging1, setIsDragging1] = useState(false);
    const [isDragging2, setIsDragging2] = useState(false);

    const handleDragEnter1 = (e) => {
        e.preventDefault();
        setIsDragging1(true);
    };
    const handleDragEnter2 = (e) => {
        e.preventDefault();
        setIsDragging2(true);
    };

    const handleDragLeave1 = (e) => {
        e.preventDefault();
        // Check if the related target is outside the component before setting isDragging1 to false
        if (!e.currentTarget.contains(e.relatedTarget)) {
            setIsDragging1(false);
        }
    };
    const handleDragLeave2 = (e) => {
        e.preventDefault();
        // Check if the related target is outside the component before setting isDragging1 to false
        if (!e.currentTarget.contains(e.relatedTarget)) {
            setIsDragging2(false);
        }
    };

    const handleDragOver1 = (e) => {
        e.preventDefault();
        setIsDragging1(true);
    };
    const handleDragOver2 = (e) => {
        e.preventDefault();
        setIsDragging2(true);
    };

    return (
        <>
            {loading ? <Loading /> :
                <main className={`px-20 py-6 flex flex-col gap-6`}
                >
                    <div className={`transition-all ease-in-out duration-200 flex flex-col gap-4 p-2 relative box-content border-4 rounded-xl border-dashed border-transparent ${isDragging1 && "border-sky-300 bg-sky-100"}`}
                        onDrop={(e) => { handleDrop1(e) }}
                        onDragOver={(e) => handleDragOver1(e)}
                        onDragEnter={(e) => handleDragEnter1(e)}
                        onDragLeave={(e) => { handleDragLeave1(e) }}
                    >
                        {
                            isDragging1 &&
                            <div className="transition-all duration-200 absolute w-full h-full text-center bg-[#ffffffbb] rounded-lg backdrop-blur-sm top-0 right-0 flex justify-center items-center">
                                <h1 className="text-4xl  antialiased font-medium  text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text">Drop your file here</h1>
                            </div>
                        }
                        <>
                            <h1 className="text-3xl w-fit antialiased font-medium text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text">Add lease data via excel (only lease data)</h1>
                            <div className="flex w-full">
                                <ol className="pl-6 text-gray-500 text-lg w-1/2">
                                    <li className="list-item list-decimal py-1.5">
                                        Download the excel template.
                                    </li>
                                    <li className="list-item list-decimal py-1.5">
                                        FIll the details  in the downloaded template.
                                    </li>
                                    <li className="list-item list-decimal py-1.5">
                                        Upload or drop the filled template.
                                    </li>
                                </ol>
                                <div className="flex flex-col justify-around w-1/2 text-lg text-gray-500">
                                    <div className="flex gap-3 items-center">
                                        Download template:
                                        <button onClick={() => { handleDownload() }} className="shadow-sm bg-white justify-self-end group rounded px-4 py-2 flex-shrink-0 justify-center gap-3 flex items-center border hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-sky-500 hover:text-white">
                                            Download
                                            <img className="w-4 group-hover:invert" src={download} alt="add" />
                                        </button>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        Upload file:
                                        <input className="items-center file-download" type="file" accept=".xlsx, .xls" onChange={(e) => { setFile1(e.target.files) }} />
                                    </div>
                                    {/* <div className="h-12 bg-gray-600 w-5"></div> */}
                                </div>
                            </div>
                        </>
                    </div>
                    <div className={`transition-all ease-in-out duration-200 flex flex-col gap-4 p-2 relative box-content border-4 rounded-xl border-dashed border-transparent ${isDragging2 && "border-sky-300 bg-sky-100"}`}
                        onDrop={(e) => { handleDrop2(e) }}
                        onDragOver={(e) => handleDragOver2(e)}
                        onDragEnter={(e) => handleDragEnter2(e)}
                        onDragLeave={(e) => { handleDragLeave2(e) }}
                    >
                        {
                            isDragging2 &&
                            <div className="transition-all duration-200 absolute w-full h-full text-center bg-[#ffffffbb] rounded-lg backdrop-blur-sm top-0 right-0 flex justify-center items-center">
                                <h1 className="text-4xl  antialiased font-medium  text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text">Drop your file here</h1>
                            </div>
                        }
                        <h1 className="text-3xl w-fit antialiased font-medium text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text">Add lease data via excel (lease data + ammortization scedule)</h1>
                        <div className="flex w-full">
                            <ol className="pl-6 text-gray-500 text-lg w-1/2">
                                <li className="list-item list-decimal py-1.5">
                                    Download the excel template.
                                </li>
                                <li className="list-item list-decimal py-1.5">
                                    FIll the details  in the downloaded template.
                                </li>
                                <li className="list-item list-decimal py-1.5">
                                    Upload or drop the filled template.
                                </li>
                            </ol>
                            <div className="flex flex-col justify-around w-1/2 text-lg text-gray-500">
                                <div className="flex gap-3 items-center">
                                    Download template:
                                    <button onClick={() => { handleDownload2() }} className="bg-white shadow-sm justify-self-end group rounded px-4 py-2 flex-shrink-0 justify-center gap-3 flex items-center border hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-sky-500 hover:text-white">
                                        Download
                                        <img className="w-4 group-hover:invert" src={download} alt="add" />
                                    </button>
                                </div>
                                <div className="flex items-center gap-3">
                                    Upload file:
                                    <input className="items-center file-download" type="file" accept=".xlsx, .xls" onChange={(e) => { setFile2(e.target.files) }} />
                                </div>
                                {/* <div className="h-12 bg-gray-600 w-5"></div> */}
                            </div>
                        </div>
                    </div>
                    <div className="border-2 bg-amber-50 rounded-xl p-4 border-amber-200 flex gap-3">
                        {/* <img style={{backgroundImage:`url(${graph9})`}} className="bg-cover w-1/2 p-6" src={warnCharacter} alt="warn"/> */}
                        <div>
                            <div className="flex items-center gap-2">
                                <img className="h-7" src={warning} alt="warning" />
                                <h1 className="text-2xl font-semibold text-amber-600">Points to remember when uploading data via excel file</h1>
                            </div>
                            <ol className="p-2 pl-12 text-gray-600 antialiased text-lg flex flex-col gap-1">
                                <li className="list-decimal ">Please ensure that no content is removed from the template, only additional data should be included.</li>
                                <li className="list-decimal ">Ensure there are no empty rows left, whether it's after the heading, in between, or at the end.</li>
                                <li className="list-decimal">Larger the file size, longer it will take for the app to process it. Please avoid pressing the reload button or closing the tab during this time.</li>
                                {/* <li className="list-decimal "></li> */}
                            </ol>
                        </div>
                    </div>
                    <div>
                        <h1 className="text-3xl w-fit antialiased font-medium text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text">Add lease data manually</h1>
                        <form className="py-2 grid  grid-flow-row grid-cols-2 gap-x-6 gap-y-3 justify-between flex-wrap">
                            <div className="input-div">
                                <h2 className="input-heading">Lessor Name</h2>
                                <div className="input-parent-div">
                                    <input className="input-lease" required type="text" placeholder="Abhishek Raj" onChange={(event) => setLesseeName(event.target.value)} />
                                </div>
                            </div>
                            <div className="input-div">
                                <h2 className="input-heading">Location</h2>
                                <div className="input-parent-div">
                                    <input className="input-lease" required type="text" placeholder="Plot 2, Rama Road" onChange={(event) => setLocation(event.target.value)} />
                                </div>
                            </div>
                            <div className="input-div">
                                <h2 className="input-heading">City</h2>
                                <div className="input-parent-div">
                                    <input className="input-lease" required type="text" placeholder="Pune" onChange={(event) => setCity(event.target.value)} />
                                </div>
                            </div>
                            <div className="input-div">
                                <h2 className="input-heading">Monthly rent</h2>
                                <div className="input-parent-div">
                                    <input className="input-lease" required type="number" min={0} placeholder="10000" onChange={(event) => setRent(event.target.value)} />
                                    <img alt="percent" src={inr} className="input-img" />
                                </div>
                            </div>
                            <div className="input-div">
                                <h2 className="input-heading">Escalation rate</h2>
                                <div className="flex items-center w-full bg-white h-full">
                                    <input className="input-lease" type="number" max={100} min={0} placeholder="10" onChange={(event) => setEscalationRate(event.target.value / 100)} />
                                    <img alt="percent" src={percentage} className="input-img2" />
                                </div>
                            </div>
                            <div className="input-div">
                                <h2 className="input-heading">Escalation period</h2>
                                <div className="flex items-center w-full bg-white h-full">
                                    <input className="input-lease" type="number" max={100} min={0} placeholder="12" onChange={(event) => setEscalationPeriod(event.target.value)} />
                                    {/* <img alt="percent" src={percentage} className="input-img2" /> */}
                                </div>
                            </div>
                            <div className="input-div">
                                <h2 className="input-heading">Discount rate</h2>
                                <div className="flex items-center w-full bg-white h-full">
                                    <input className="input-lease" type="number" max={100} min={0} placeholder="12" onChange={(event) => setInterest(event.target.value / 100)} />
                                    <img alt="percent" src={percentage} className="input-img2" />
                                </div>
                            </div>
                            <div className="input-div">
                                <h2 className="input-heading">Start Date</h2>
                                <input className="input-lease" type="date" max={endDate} onChange={(event) => setStartDate(event.target.value)} />
                            </div>
                            <div className="input-div">
                                <h2 className="input-heading">End Date</h2>
                                <input className="input-lease" type="date" min={startDate} onChange={(event) => setEndDate(event.target.value)} />
                            </div>
                            <div className="input-div">
                                <h2 className="input-heading">Security Deposit</h2>
                                <div className="input-parent-div">
                                    <input className="input-lease" required type="number" min={0} placeholder="10000" onChange={(event) => setSecurityDeposit(event.target.value)} />
                                    <img alt="percent" src={inr} className="input-img" />
                                </div>
                            </div>
                            <div className="input-div">
                                <h2 className="input-heading">Asset type</h2>
                                <div className="input-parent-div">
                                    {/* <img alt="percent" src={inr} className="input-img" /> */}
                                    {/* <input className="input-lease" type="text" placeholder="Laptop" onChange={(event) => setType(event.target.value)} /> */}
                                    <select onChange={(e) => setType(e.target.value)} >
                                        <option value="property" >Property / Real estate</option>
                                        <option value="equipment-machinery" >Equipment and machinery</option>
                                        <option value="vechicle" >Vechicle</option>
                                    </select>
                                </div>
                            </div>
                            <div className="input-div">
                                <h2 className="input-heading">Agree Date</h2>
                                <div className="input-parent-div">
                                    {/* <img alt="percent" src={inr} className="input-img" /> */}
                                    <input className="input-lease" type="date" placeholder="Laptop" onChange={(event) => setAgreeDate(event.target.value)} />
                                </div>
                            </div>
                            <div className="input-div">
                                <h2 className="input-heading">Possession Date</h2>
                                <div className="input-parent-div">
                                    {/* <img alt="percent" src={inr} className="input-img" /> */}
                                    <input className="input-lease" type="date" placeholder="Laptop" onChange={(event) => setPossesDate(event.target.value)} />
                                </div>
                            </div>
                            <div className="input-div">
                                <h2 className="input-heading">Rent in</h2>
                                <div className="input-parent-div">
                                    {/* <img alt="percent" src={inr} className="input-img" /> */}
                                    <select onChange={(e) => { setPaymentType(e.target.value) }}>
                                        <option value="arrear">Arrear</option>
                                        <option value="advance">Advance</option>
                                    </select>
                                    {/* <input className="input-lease" type="text" placeholder="Laptop" onChange={(event) => paymentType(event.target.value)} /> */}
                                </div>
                            </div>
                        </form>
                        <button className="px-4 py-2 mb-12 w-40 justify-center gap-3 flex items-center rounded border hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-sky-500 hover:text-white" type="submit" onClick={(e) => submitForm(e)}>Create lease</button>
                    </div>
                    {/* <button className="relative w-fit p-2 px-4  border before:hover:w-full before:hover:transition-all before:duration-300 before:content-[''] before:absolute before:bg-gradient-to-bl hover:border-white before:from-sky-300 before:to-indigo-200 before:w-0 before:h-full before:left-0 before:top-0 before:-z-10" type="submit" onClick={(e) => submitForm(e)}>Create lease</button> */}
                </main>
            }
        </>

    )
}